export default __webpack_public_path__ + "static/media/fossilizing.0ae6c579.svg";